import {
  GET_AGENCY,
  GET_AGENCY_SUCCESS,
  GET_AGENCY_FAIL,
  DELETE_AGENCY,
  DELETE_AGENCY_SUCCESS,
  DELETE_AGENCY_FAIL,
  UPDATE_AGENCY,
  UPDATE_AGENCY_SUCCESS,
  UPDATE_AGENCY_FAIL,
  ADD_NEW_AGENCY,
  ADD_AGENCY_SUCCESS,
  ADD_AGENCY_FAIL,
  AGENCY_LOADING,
  AGENCY_RESET,
  AGENCY_RESET_CREATE
} from "./actionType";

export const resetAgencyState = (actionType) => ({
  type: AGENCY_RESET,
  payload: { actionType },
});


export const resetAgencyCreateState = (actionType) => ({
  type: AGENCY_RESET_CREATE,
  payload: { actionType }
});

export const getAgencySuccess = (actionType, data) => ({
  type: GET_AGENCY_SUCCESS,
  payload: { actionType, data },
});

export const getAgencyFail = (actionType, error) => ({
  type: GET_AGENCY_FAIL,
  payload: { actionType, error },
});

export const getAgency = data => ({
  type: GET_AGENCY,
  payload: data,
});

export const getAgencyLoading = () => ({
  type: AGENCY_LOADING
});

export const deleteAgency = data => ({
  type: DELETE_AGENCY,
  payload: data,
});

export const deleteAgencySuccess = data => ({
  type: DELETE_AGENCY_SUCCESS,
  payload: data,
});

export const deleteAgencyFail = error => ({
  type: DELETE_AGENCY_FAIL,
  payload: error,
});

export const updateAgency = data => ({
  type: UPDATE_AGENCY,
  payload: data,
});

export const updateAgencyFail = error => ({
  type: UPDATE_AGENCY_FAIL,
  payload: error,
});

export const updateAgencySuccess = data => ({
  type: UPDATE_AGENCY_SUCCESS,
  payload: data,
});

export const addNewAgency = data => ({
  type: ADD_NEW_AGENCY,
  payload: data,
});

export const addAgencySuccess = data => ({
  type: ADD_AGENCY_SUCCESS,
  payload: data,
});

export const addAgencyFail = error => ({
  type: ADD_AGENCY_FAIL,
  payload: error,
});